import React from "react";

interface Props {
  count: number;
  filteredCount: number;
  allSelected: boolean;
  onSelectAll: () => void;
  onClear: () => void;
  onDownload: () => void;
  /** Signed-in curators only: mint a magic link for the current selection. */
  onMagicLink?: () => void;
}

/**
 * Floating action bar shown when the user has selected one or more assets on the
 * main grid. Bottom-center so it stays put while scrolling and doesn't collide
 * with the admin queue panel (bottom-right, admin-mode only).
 */
export function SelectionBar({ count, filteredCount, allSelected, onSelectAll, onClear, onDownload, onMagicLink }: Props) {
  if (count === 0) return null;
  return (
    <div className="selection-bar" role="region" aria-label="Selected assets">
      <span className="selection-bar-count">
        <strong>{count.toLocaleString()}</strong> selected
      </span>
      {!allSelected && filteredCount > count && (
        <button className="selection-bar-link" onClick={onSelectAll}>
          Select all {filteredCount.toLocaleString()}
        </button>
      )}
      <button className="selection-bar-link" onClick={onClear}>
        Clear
      </button>
      {onMagicLink && (
        <button className="selection-bar-magic" onClick={onMagicLink} title="Create a shareable magic link for these files">
          Magic link…
        </button>
      )}
      <button className="selection-bar-download" onClick={onDownload}>
        Download…
      </button>
    </div>
  );
}
